<template>
  <VForms
    v-if="petList"
    :initial-values="getInitialValues()"
    :validation-schema="validations"
    @submit="handleSubmit"
  >
    <template slot-scope="props">
      <form
        class="pet-form"
        @reset.prevent="props.handleReset"
        @submit.prevent="props.handleSubmit"
      >
        <v-container
          grid-list-md
          align-center
          fill-height
        >
          <v-layout column>
            <v-layout
              column
              fill-height
              class="pet-content"
            >
              <div class="subheading mb-2">
                {{ $t('messages.chooseOrAddPet') }}
              </div>
              <PetSelect
                :form="props"
                :pet-list="petList"
              />
            </v-layout>
            <StepperButtons
              :change-step="changeStep"
              :active="active"
              :number-of-steps="numberOfSteps"
              :form="props"
            />
          </v-layout>
        </v-container>
      </form>
    </template>
  </VForms>
</template>

<script>
import { Form as VForms } from '@v-forms/core'
import { required } from 'vuelidate/lib/validators'
import { mapState, mapActions } from 'vuex'
import {
  PET_LIST_KEY,
  ACTION_GET_PETS,
  ACTION_SET_SELECTED_PET,
} from '../../../store/types/pets.types'
import PetSelect from './PetSelect'
import StepperButtons from '../StepperButtons'

export default {
  name: 'PetStep',
  components: {
    StepperButtons,
    PetSelect,
    VForms,
  },
  props: {
    active: {
      type: Number,
      required: true,
    },
    changeStep: {
      type: Function,
      required: true,
    },
    numberOfSteps: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      pet: null,
      validations: {
        pet: { required },
      },
    }
  },
  computed: {
    ...mapState({
      petList: state => state.pets[PET_LIST_KEY],
    }),
  },
  mounted() {
    this.getPets()
  },
  methods: {
    handleSubmit(values, actions) {
      this.savePet(values.pet)
      actions.setSubmitting(false)
      this.changeStep(this.active + 1)
    },
    getInitialValues() {
      const { length } = this.petList
      const pet = length > 0 ? this.petList[length - 1].id : null
      return { pet }
    },
    ...mapActions({
      getPets: ACTION_GET_PETS,
      savePet: ACTION_SET_SELECTED_PET,
    }),
  },
}
</script>

<style lang="stylus" scoped>
  .pet-content {
    margin-top: 50px !important;
  }
  .pet-form {
    height: 100%
  }
</style>
